import type { CSSProperties } from 'react';
import type { SourceObject, Style } from '@react-pdf/types';
import { Image, Text, View } from '@react-pdf/renderer';
import { useTemplateContext } from '../context/useTemplateContext';
// context for customer invoice
export const TextWrapper = ({
  children,
  style,
  onClick,
}: {
  children: React.ReactNode;
  style?: Style | Style[] | undefined;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
}) => {
  const { templateData } = useTemplateContext();
  return templateData.isDom ? (
    <div
      className="!leading-tight"
      onClick={onClick}
      style={style as CSSProperties}
    >
      {children}
    </div>
  ) : (
    <Text style={style as Style}>{children}</Text>
  );
};

export const DivWrapper = ({
  children,
  style,
  onClick,
  fixed,
  pageBreak,
}: {
  children?: React.ReactNode;
  style?: Style | Style[];
  onClick?: React.MouseEventHandler<HTMLDivElement>;
  fixed?: boolean;
  pageBreak?: boolean;
}) => {
  const { templateData } = useTemplateContext();
  return templateData.isDom ? (
    <div onClick={onClick} style={style as CSSProperties}>
      {children}
    </div>
  ) : (
    <View break={pageBreak} fixed={fixed} style={style}>
      {children}
    </View>
  );
};

export const ImageWrapper = ({
  source,
  style,
  onClick,
}: {
  source: string | Record<string, string>;
  style?: Style | Style[] | undefined;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
}) => {
  const { templateData } = useTemplateContext();
  const _source = typeof source === 'string' ? encodeURI(source) : source;

  return templateData.isDom ? (
    <img
      src={typeof _source === 'string' ? _source : _source.uri}
      onClick={onClick}
      style={style as CSSProperties}
    />
  ) : (
    <Image src={_source as SourceObject} style={style} />
  );
};
